import Vue from 'vue'
import APP_CONFIG from './config'
import App from './app.vue'
import './registerServiceWorker'
import router from '@/ox/src/router/index.js'
import store from './store'
import Vuetify from '@/ox/src/plugins/vuetify'
import ox from '@/ox/src/plugins/ox'
import globalMixin from '@/mixins/global'
import oxGloablMixin from '@/ox/src/mixins/global'
import faker from 'faker'
import Server from '@/ox/src/plugins/server'
import GetToken from '@/ox/src/plugins/gettoken'
import PortalVue from 'portal-vue'
import Filters from '@/ox/src/filters'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import persianDate from 'persian-date'

Vue.use(VueLodash, { name: 'lo', lodash: lodash })
Vue.mixin(globalMixin)
Vue.mixin(oxGloablMixin)
Vue.use(PortalVue)
Vue.use(HighchartsVue)
Filters(APP_CONFIG)


Highcharts.setOptions(APP_CONFIG.chartTheme);

String.prototype.toEnglishDigits = function () {
  return this.replace(/[۰-۹]/g, function (chr) {
    var persian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return persian.indexOf(chr);
  });
};

Highcharts.dateFormats = {
    'a': function(ts){return new persianDate(ts).format('dddd')},
    'A': function(ts){return new persianDate(ts).format('dddd')},
    'd': function(ts){return new persianDate(ts).format('DD')},
    'e': function(ts){return new persianDate(ts).format('D')},
    'b': function(ts){return new persianDate(ts).format('MMMM')},
    'B': function(ts){return new persianDate(ts).format('MMMM')},
    'm': function(ts){return new persianDate(ts).format('MM')},
    'y': function(ts){return new persianDate(ts).format('YY')},
    'Y': function(ts){return new persianDate(ts).format('YYYY')},
    'W': function(ts){return new persianDate(ts).format('ww')}
};

Vue.mixin({
  beforeCreate () {
    faker.locale = APP_CONFIG.locale
    this.faker = faker
    this.APP_CONFIG = APP_CONFIG
  }
})

// NOTE: add route before hooks here
router.beforeEach((to, from, next) => {
  next()
})

const vuetify = Vuetify(APP_CONFIG)

const token = GetToken()
if (token) {
  store.commit('auth/setToken', token)
}

// NOTE: add route before hooks here
router.beforeEach((to, from, next) => {
  if (GetToken()) {
    next()
  } else if (!token &&
    to.path !== '/forgetpass' &&
    to.path !== '/emailactivated' &&
    to.path !== '/emailactivationfailed' &&
    to.path !== '/resetPassword' &&
    to.path !== '/login') {
    router.push('/login')
  } else {
    next()
  }
})

const requestInterceptor = (config) => {
  config.headers.common.authorization = store.getters['auth/token']
  return config
}

const responseInterceptor = (error) => {
  let responseStatus = null
  if (error) {
    responseStatus = error.response ? error.response.status : null
  }
  if (responseStatus === 401 || responseStatus === 422) {
    store.dispatch('auth/logout')
      .then(() => {
        router.push('/login')
      })
  }
  if (responseStatus === 404) {
    return Promise.reject(error)
  }
  if (responseStatus === 400) {
    return Promise.reject(error)
  }
  return error
}

const server = Server(APP_CONFIG, token, requestInterceptor, responseInterceptor)

window.SERVER = server
window.APP_CONFIG = APP_CONFIG

store.server = server

Vue.server = server
Vue.config.productionTip = false

new Vue({
  router,
  store,
  ox,
  vuetify,
  render: h => h(App)
}).$mount('#app')
